// DS: i7.9
import React from 'react';
import IconWrap from '../../IconWrap';
const TextSize = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M14 5a1 1 0 011 1v1a1 1 0 01-1 1h-4v10a1 1 0 01-1 1H8a1 1 0 01-1-1V8H4a1 1 0 01-1-1V6a1 1 0 011-1zm6 5a1 1 0 011 1v1a1 1 0 01-1 1h-2v5a1 1 0 01-1 1h-1a1 1 0 01-1-1v-5h-2a1 1 0 01-1-1v-1a1 1 0 011-1z"
    })));
};
TextSize.displayName = 'TextSize';
export default TextSize;
